module.exports = __webpack_public_path__ + "img/DesktopMenuTile-inactive.3f701553.svg";